import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import { BREAKPOINTS } from '@src/styles/config';

export const StyledPaymentSMSDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: 640px;
    width: 575px;
    border-radius: 16px;
  }

  .wrapper {
    padding: 16px 32px 32px 32px;
    display: flex;
    flex-direction: column;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .close-icon {
    margin-left: auto;
    cursor: pointer;
    color: #1e164ea3;
    margin-bottom: 20px;
  }

  .title {
    color: ${COLOR.darkGray};
    font-weight: 700;
    font-size: 20px;
    padding-bottom: 24px;
    text-align: center;
    flex-grow: 1;
  }

  .payment-info {
    border: 1px solid #3c3c4329;
    border-radius: 16px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }

  .payment-info-item {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  .unit-vn {
    color: #1565c0;
    font-size: 16px;
    font-weight: 510;
    text-decoration: underline;
    line-height: 24px;
  }

  .price {
    color: #1565c0;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
  }

  .payment-syntax-container {
    background-color: rgba(21, 101, 192, 0.08);
    border-radius: 16px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .payment-syntax-title {
    color: ${COLOR.darkGray};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  .payment-syntax-content {
    color: #1565c0;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;

    .send-text {
      color: rgba(28, 28, 30, 0.48);
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
    }
  }

  .payment-note {
    color: rgba(28, 28, 30, 0.48);
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
    line-height: 24px;
    margin-top: 8px;
    margin-bottom: 24px;
    text-align: center;
  }

  .payment-warning {
    padding: 8px;
    border-radius: 16px;
    background-color: rgba(255, 149, 0, 0.08);
    display: flex;
    gap: 8px;
    font-size: 14px;

    .img-icon-warning {
      height: 24px;
    }
  }

  .mobile-sms {
    display: none;
  }

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    .wrapper {
      padding: 16px;
    }
    .mobile-sms {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 24px;

      .button-sms {
        background-color: ${COLOR.primary};
        color: ${COLOR.darkBlue};
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        text-transform: none;
        padding: 8px 24px;
        border-radius: 24px;
      }
    }
  }

  .unit-price {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-transform: lowercase;
    padding-bottom: -2px;
  }

  .underlined {
    text-decoration: underline;
  }

  .qr-payment-content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .time {
    font-size: 14px;
    font-weight: 400;
    color: ${COLOR.label[80]};
  }

  .price-value {
    font-weight: 700;
    font-size: 20px;
    color: ${COLOR.black.default} !important;
  }

  .time-value {
    font-weight: 700;
    color: ${COLOR.black.default} !important;
    width: 40px;
    display: inline-block;
  }

  .divider {
    margin: 16px 0;
  }
`;
